'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _enforceFunction2 = require('./internal/_enforceFunction');

var _enforceFunction3 = _interopRequireDefault(_enforceFunction2);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function partialApply(operation, args) {
  (0, _enforceFunction3.default)(operation);
  var isArray = Array.isArray(args);
  if (!isArray && !_immutable.Iterable.isOrdered(args)) {
    throw new Error('expected `args` to be an Array or OrderedIterable but got `' + args + '`');
  }

  var arrayArgs = isArray ? args : args.toArray();
  return operation.bind.apply(operation, [null].concat(_toConsumableArray(arrayArgs)));
}

/**
 * Like `transmute/partial`, but takes an Array or Iterable of arguments to pass
 * to `operation` rather than a dynamic number of args. Unlike `partial` it is
 * curried.
 *
 * partial : partialApply :: Function.prototype.call : Function.prototype.apply
 *
 * @example
 * const add = (a, b, c) => a + b + c;
 * const add11 = partialApply(add, [5, 6]);
 * add11(7); // returns 18
 *
 * @param  {Function}  operation  the function to bind.
 * @param  {Array|Iterable}  args  ordered collection of arguments to bind to `fn`.
 * @return {Function}
 */
exports.default = (0, _curry2.default)(partialApply);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/partialApply.js
// module id = 382
// module chunks = 0 1